import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon, LayersIcon, ArrowUpRightIcon } from 'lucide-react';
interface QuickLink {
  label: string;
  href: string;
}
const QUICK_LINKS: QuickLink[] = [{
  label: 'El método',
  href: '#metodo'
}, {
  label: 'Los 5 tomos',
  href: '#tomos'
}, {
  label: 'Resultados',
  href: '#beneficios'
}, {
  label: 'Obras sociales',
  href: '#obras-sociales'
}, {
  label: 'Para quién es',
  href: '#para-quien'
}, {
  label: 'Recursos extra',
  href: '#bonos'
}, {
  label: 'Preguntas frecuentes',
  href: '#faq'
}, {
  label: 'Precio y acceso',
  href: '#comprar'
}];
const LEGAL_LINKS: QuickLink[] = [{
  label: 'Términos y condiciones',
  href: '#faq'
}, {
  label: 'Política de privacidad',
  href: '#faq'
}, {
  label: 'Política de reembolso',
  href: '#faq'
}];
export function Footer() {
  return <footer id="site-footer" className="relative overflow-hidden bg-sand" data-id="element-151" data-mp="29y5gjzn2fiuh">
      <div className="h-px w-full bg-gold/30" aria-hidden data-id="element-152" data-mp="2eyt7klbanzop" />
      <div className="pointer-events-none absolute -bottom-28 -right-20 h-72 w-72 rounded-full bg-stone/50 blur-3xl" aria-hidden data-id="element-153" data-mp="2ew6yuico3e4w" />

      <div className="relative mx-auto max-w-6xl px-5 py-12 sm:py-14" data-id="element-154" data-mp="3gb8ses4cwuqb">
        <div className="grid gap-8 md:grid-cols-3 md:gap-8 lg:gap-12" data-id="element-155" data-mp="3v7gexz38m88r">
          {/* Marca y producto */}
          <div className="md:col-span-1" data-id="element-156" data-mp="3q8wts0wgx0hg">
            <p className="font-display text-xl font-bold uppercase leading-tight text-charcoal sm:text-2xl" data-id="element-157" data-mp="3q725qdpwgs95">
              Método <span className="text-gold-deep" data-id="element-158" data-mp="80xjc6sbqxik">Consultorio Rentable</span>
            </p>
            <p className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-gold/40 bg-ivory px-3 py-1 text-[0.62rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-159" data-mp="33nlc2qvddj4">
              <LayersIcon className="h-3 w-3 text-gold-deep" aria-hidden data-id="element-160" data-mp="cu8ugk4660ga" />
              5 tomos + 5 recursos extra
            </p>
            <p className="mt-4 max-w-sm text-[0.82rem] leading-relaxed text-charcoal/65" data-id="element-161" data-mp="qr5gm89cetqu">
              El sistema de implementación para odontólogos con consultorio propio que quieren
              detectar dónde pierden dinero, convertir mejor consultas y presupuestos y hacer rendir
              más cada hora de sillón.
            </p>
            <p className="mt-4 max-w-sm font-display text-sm font-bold uppercase leading-snug text-charcoal/80" data-id="element-162" data-mp="13t0sqdfhz4v7">
              Detectar · Convertir · Recuperar · Rentabilizar
            </p>
          </div>

          {/* Enlaces rápidos */}
          <nav aria-label="Enlaces rápidos" data-id="element-163" data-mp="1clch7tr1wi8j">
            <h2 className="text-[0.62rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-164" data-mp="1hk5xftxq2nce">
              Explorá el sistema
            </h2>
            <ul className="mt-4 space-y-2" data-id="element-165" data-mp="1mkjvcj5m0gwp">
              {QUICK_LINKS.map(link => <li key={link.label} data-id="element-166" data-mp="1rid2pfinfgyk">
                  <a href={link.href} className="group inline-flex items-center gap-1.5 text-[0.82rem] text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-167" data-mp="3ob55fzlt0v3j">
                    {link.label}
                    <ArrowUpRightIcon className="h-3.5 w-3.5 text-gold/60 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-gold-deep" aria-hidden data-id="element-168" data-mp="25nlr0zx6eyxl" />
                  </a>
                </li>)}
            </ul>
          </nav>

          {/* Soporte */}
          <div data-id="element-169" data-mp="2pbuw2ajtizei">
            <h2 className="text-[0.62rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-170" data-mp="2pdfq7z280gbu">
              Soporte
            </h2>
            <ul className="mt-4 space-y-2 text-[0.82rem]" data-id="element-171" data-mp="2kfe5l9p5c8y9">
              <li data-id="element-172" data-mp="2fd5cmdc9x6w5">
                <a href="mailto:soporte@creativodigital.shop" className="inline-flex items-center gap-2.5 text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-173" data-mp="2fdow3yhko3ca">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ivory ring-1 ring-stone" data-id="element-174" data-mp="2rug198idf4l2">
                    <MailIcon className="h-4 w-4 text-gold-deep" aria-hidden data-id="element-175" data-mp="2iv1ccdhur22o" />
                  </span>
                  soporte@creativodigital.shop
                </a>
              </li>
              <li data-id="element-176" data-mp="2nrrs0zpqvvnk">
                <a href="https://instagram.com/creativodigitalstudio" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-177" data-mp="3bk013tghd2gy">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ivory ring-1 ring-stone" data-id="element-178" data-mp="1q6dqogt6yaol">
                    <InstagramIcon className="h-4 w-4 text-gold-deep" aria-hidden data-id="element-179" data-mp="1v5qlbnqb0m1q" />
                  </span>
                  @creativodigitalstudio
                </a>
              </li>
              <li data-id="element-180" data-mp="1ine6wa1tih4p">
                <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-181" data-mp="1iltcckfi6y6u">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ivory ring-1 ring-stone" data-id="element-182" data-mp="zwmxx9lqssqu">
                    <GlobeIcon className="h-4 w-4 text-gold-deep" aria-hidden data-id="element-183" data-mp="1dotegwst51qt" />
                  </span>
                  www.creativodigital.shop
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Legales */}
        <ul className="mt-8 flex flex-wrap gap-x-5 gap-y-2 text-[0.72rem] text-charcoal/45" data-id="element-184" data-mp="g8dyqfls7mhu">
          {LEGAL_LINKS.map(link => <li key={link.label} data-id="element-185" data-mp="2gbf2d8ir7cof">
              <a href={link.href} className="transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-186" data-mp="2gadiqfno9hv3">
                {link.label}
              </a>
            </li>)}
        </ul>

        {/* Cierre */}
        <div className="mt-5 border-t border-stone pt-5" data-id="element-187" data-mp="1xc16gl1grrva">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between" data-id="element-188" data-mp="1xdm1ebroxcto">
            <p className="text-[0.72rem] text-charcoal/50" data-id="element-189" data-mp="22be1vu6ei79h">
              © Creativo Digital™ 2026 — Todos los derechos reservados.
            </p>
            <p className="text-[0.72rem] text-charcoal/45" data-id="element-190" data-mp="2bbaprtkyv23h">
              Un producto de{' '}
              <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="font-semibold text-gold-deep transition-colors hover:text-gold focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-191" data-mp="3ipe112xf9svo">
                Creativo Digital
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>;
}